import { GET_ERRORS, RESET_ERRORS } from '../actions/types'

const initialState = {
  isAuthenticated: false,
  user: {},
  objects: {},
  object: {},
  page: {},
  pages: {},
  qsServer: {},
  users: {},
  group: {},
  groups: {},
  passwordReset: {},
  siteLicence: {},
  loading: true,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return action.payload
    case RESET_ERRORS:
      return {}
    default:
      return { ...state }
  }
}
